$(document).ready(function () {
  $("a.menu-list-item").mouseover(function () {
    $(".menu-mega").attr("hidden", "hidden");
    $(this).parent(".mega-menu-div").find(".menu-mega").removeAttr("hidden");
  });
  $(".mega-menu-div").mouseleave(function () {
    $(".menu-mega").attr("hidden", "hidden");
  });

  // popup image jq start

  $(".close_popups").click(function () {
    $(".popuimageshow").hide();
    $("body").removeClass("pop-overlay");
  });

  $(".image_opendiv .popup_images").click(function () {
    $(".popuimageshow").fadeIn(500);
    $("body").addClass("pop-overlay");
  });

  $(document).ready(function () {
    var numItems = $(".open_image_opendiv").find(".popup_images").length;
    // console.log(numItems);
    $(".popup_topheads").find("span.image_leghth").html(numItems);
  });

  // popup image jq start

  // product page jq start

    $(".thumbnail-list").slick({
      slidesToShow: 5,
      slidesToScroll: 2,
      autoplay: false,
      arrows: true,
      vertical: false,
      infinite: false,

      prevArrow:
        "<button type='button' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='15 18 9 12 15 6'></polyline></svg></button>",

      nextArrow:
        "<button type='button' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='9 18 15 12 9 6'></polyline></svg></button>",

      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            vertical: false,
          },
        },
      ],
    });

    $(".slider_product_image").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    vertical: false,
    infinite: false,
    prevArrow:
      "<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'><polyline points='18 15 12 9 6 15'></polyline></svg></button>",
    nextArrow:
      "<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'><polyline points='6 9 12 15 18 9'></polyline></svg></button>",
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
     {
      breakpoint: 992,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  });
  

  // product page jq end

  // variant meta data show in  js start

  $(".input__list input").click(function () {
    // $(".bottom_variant_show ul li").removeClass("active_varmeta");
    var input_value = $(this).attr("value");
    $(".bottom_variant_show ul li").each(function () {
      var input_varmeta = $(this).attr("data-var");
      if (input_value == input_varmeta) {
        $(this).addClass("active_varmeta");
      } else {
        $(this).removeClass("active_varmeta");
      }
    });
  });

// $(window).on("load", function () {
//   // Function to update variant description
//   function updateVariantDescription() {
//     $(".bottom_variant_show ul li").removeClass("active_varmeta");

//     // Get the value of the selected variant
//     var loadinput_value = $(".input__list input:checked").val();
//     // console.log("Selected variant value:", loadinput_value);

//     // Update the variant description
//     $(".bottom_variant_show ul li").each(function () {
//       var input_varmeta = $(this).attr("data-var");
//       // console.log("Variant data-var:", input_varmeta);
//       if (loadinput_value === input_varmeta) {
//         $(this).addClass("active_varmeta");
//       }
//     });
//   }

//   updateVariantDescription();

//   $(".input__list input").on("change", function () {
//     updateVariantDescription();
//   });

//   $(".slider-buttons__previous, .slider-buttons__next").on("click", function () {
//     var isNext = $(this).hasClass("slider-buttons__next");
//     var inputs = $(".input__list input");
//     var currentIndex = inputs.index($(".input__list input:checked"));

//     var newIndex = isNext ? currentIndex + 1 : currentIndex - 1;
//     if (newIndex >= inputs.length) {
//       newIndex = 0; 
//     } else if (newIndex < 0) {
//       newIndex = inputs.length - 1; 
//     }
//     $(inputs[newIndex]).prop("checked", true).trigger("change");
//     updateVariantDescription();
//   });
// });

// variant meta data show in  js end

// scrollbar jq start



// scrollbar jq end


// Product page image variants jq start


var orignal_thumnail_image = $(".active_labels").find('img').attr('src');
var orignal_var_data = $(".active_labels").find('.variant_meta_value').text();
  //console.log(orignal_thumnail_image);
  // console.log(orignal_var_data);


  
// $(".main-product__block-variant-picker .card-swatches__button").mouseover(function () {
//  var variants_image_url =  $(this).find('img').attr('src');
//   var text_shows =  $(this).find('.variant_meta_value').text();
//    $(".main-product__media-gallery .main-product__media-gallery__inner-media[active]").each(function () {
//       $(this).find('img').attr('srcset', variants_image_url);
//      });
//   $('.bottom_variant_show.show_media_text').find('.active_varmeta').text(text_shows);
  
// });

$(".main-product__block-variant-picker .card-swatches__button").click(function() {
 $('.main-product__block-variant-picker .card-swatches__button').removeClass('active_labels');
 $(this).addClass('active_labels');
  orignal_thumnail_image = $(this).find('img').attr('src');
  orignal_var_data =  $(this).find('.variant_meta_value').text()
});

// $(".main-product__block-variant-picker .card-swatches__button").mouseout(function () {
//    $(".main-product__media-gallery .main-product__media-gallery__inner-media[active]").each(function () {
//       $(this).find('img').attr('srcset', orignal_thumnail_image);
//      });
//   $('.bottom_variant_show.show_media_text').find('.active_varmeta').text(orignal_var_data);
// });  
  
// product page soldout jq start
  
var $varRadiosImages = $('<div class="var_radios images"></div>');
var $image = $('<img>').attr('src', 'https://cdn.shopify.com/s/files/1/0652/0733/7060/files/BACK_SOON.png?v=1721055051');
$varRadiosImages.append($image);

$('.var_radios:last').after($varRadiosImages);

var $soldElements = $('.var_radios.sold_out');

if ($soldElements.length > 0) {
   $('.var_radios.images').addClass('show_backsoon_image');
    $soldElements.each(function() {
        var $this = $(this);
        $('.var_radios.images:last').after($this);
    });
}


// product page soldout jq start

// collection filter jq start
$(document).on('click', '.all_input_filters input', function(e) {
    e.preventDefault();
  
    var $ul = $(this).closest('ul');
    var $allCheckbox = $(this);
    var isChecked = $allCheckbox.attr('checked');
    if (isChecked) {
        $ul.find('input[type="checkbox"]').prop('checked', false);
      $allCheckbox.attr('checked', false)
    } else {
        $ul.find('input[type="checkbox"]').prop('checked', true);
    }

    var checkedTags = $ul.find('input[type="checkbox"]:checked').map(function() {
        return $(this).val();
    }).get();

    // Create the base URL and tag query
    var baseUrl = '?filter.v.price.gte=&filter.v.price.lte=';
    var tagQuery = checkedTags.map(function(tag) {
        return 'filter.p.tag=' + encodeURIComponent(tag.trim());
    }).join('&');
    var finalUrl = baseUrl + '&' + tagQuery;
    window.location.href = finalUrl;
});

    var urlParams = new URLSearchParams(window.location.search);
    var tags = urlParams.getAll('filter.p.tag');
    $('ul').each(function() {
        var $ul = $(this);
        var $allCheckbox = $ul.find('.all_input_filters input[type="checkbox"]');
        var allChecked = true;
        $ul.find('input[type="checkbox"]').not($allCheckbox).each(function() {
            var checkboxValue = $(this).val();
            if (tags.includes(checkboxValue)) {
                $(this).prop('checked', true);
            } else {
                $(this).prop('checked', false);
                allChecked = false; // Mark as false if any checkbox is unchecked
            }
        });
        $allCheckbox.attr('checked', allChecked);
      
    });

    $(document).on('click', '#FiltersFormLarge .all_input_filters', function() {
        $(this).find('input').attr('checked', 'checked');
   });
  $(document).on('click', '#FiltersFormMobile .all_input_filters', function() {
        $(this).addClass('checkedd_input');
   });
    $(document).on('click', '.filters-mobile-header .scroller-tabs__item', function() {
       // $('.filters-mobile-header .scroller-tabs__item').not(this).removeAttr('active');
      $('.filters-mobile-header .scroller-tabs__item .button.tap').attr('aria-expanded', false);
      $(this).find('.button.tap').attr('aria-expanded', true);
    });
  

// collection filter jq end
  //menu js
              var currentUrl = window.location.href;
              var queryString = currentUrl.split('?=')[1]; // Assumes query string is present
            if (queryString) {
              var decodedQueryString = queryString.replace(/%20/g, ' ');
              $('.itg_upcoming-brands .page-content.rte p strong').text(decodedQueryString);            
            } else {
                $('.result').text('No query string found.');
            }


  // product page jq start


$('.price-details .price_hide').addClass('hide');
 $('.var_radios input').each(function(){
var check_val = $(this).attr('checked')
  if(check_val){
    $('.price-details .small_price_min-max').addClass('hide');
     $('.price-details .price_hide').removeClass('hide');
  }else{
    // $('.price-details .price').addClass('hide');
  }
   });

 
  //variant change
  $(document).on('click', '.var_radios .sr-only', function() {
    var select_var  = $(this).val()
    //console.log(select_var)
    $('.custom_dropdown_box .input__select option').each(function(){
      var same_op = $(this).val()
       //console.log(same_op)
      if(select_var == same_op){
        $(this).attr('selected', 'selected');
      }else{
      $(this).removeAttr('selected', 'selected');
      }
   }); 
});

 
  $('.custom_dropdown_box .input__select').on('change', function() {
    var select_var  = $(this).val()
   // console.log(select_var)
    $('.var_radios .sr-only').each(function(){
      var same_op = $(this).val()
       //console.log(same_op)
      if(select_var == same_op){
        $(this).trigger('click');
      }else{
      $(this).removeAttr('checked', 'checked');
      }
   }); 
  });
 
  // product page jq end
 $(document).ready(function(){
    $(document).on('click', '.variants-data', function() {
   $(this).siblings('.variants-data').removeClass('varint-active');
      $(this).addClass('varint-active');
      var data = $(this).data('id');
     $(this).closest('.vrnt').next('form').find('.input-hidden').val(data);

    });
  });
    

});

document.addEventListener("DOMContentLoaded", function () {
  const variantRadios = document.querySelectorAll('.var_radios input[type="radio"]');
  const prevButton = document.querySelector('.slider-buttons__previous');
  const nextButton = document.querySelector('.slider-buttons__next');

  const colorTextOutput = document.querySelector(
    '.color-showtext .cst-product_values.variant_data'
  );

  const colorShownText = document.querySelector('.color-shown-text');
  const colorImageWarning = document.querySelector('.color-image-warning');

  let variantHasBeenSelected = false;

  var inputList = document.querySelectorAll(".input__list input");

  if (inputList.length) {
    const anyChecked = Array.from(inputList).some(rb => rb.checked);

    if (anyChecked) {
      document.querySelector(".cst-product_values.variant_data")?.classList.remove('hidden');
      document.querySelector(".cst-product_values.metafield_data")?.classList.add('hidden');
    } else {
      document.querySelector(".cst-product_values.metafield_data")?.classList.remove('hidden');
      document.querySelector(".cst-product_values.variant_data")?.classList.add('hidden');
    }

    inputList.forEach(input => {
      input.addEventListener('change', () => {
        variantHasBeenSelected = true;

        document.querySelectorAll('.bottom_variant_show ul li').forEach(item => {
          item.classList.remove('active_varmeta');

          if (item.dataset.var === input.value) {
            item.classList.add('active_varmeta');
          }
        });

        document.querySelector(".cst-product_values.variant_data")?.classList.remove('hidden');
        document.querySelector(".cst-product_values.metafield_data")?.classList.add('hidden');

        colorShownText?.classList.remove('hidden');
        colorImageWarning?.classList.add('hidden');
      });
    });
  }

  const featuredImage = document
    .querySelector('.main-product__media-gallery__inner-media img')
    ?.src
    ?.split('?')[0];

  let currentIndex = [...variantRadios].findIndex(radio => radio.checked);

  function updateGalleryImage(imgSrc) {
    const galleryMedia = document.querySelectorAll(
      '.main-product__media-gallery__inner-media'
    );

    galleryMedia.forEach(media => {
      media.removeAttribute('active');

      const image = media.querySelector('img');

      if (image && image.src.includes(imgSrc)) {
        media.setAttribute('active', '');
      }
    });
  }

  function selectVariant(index) {
    console.log("index", index);

    if (index < 0 || index >= variantRadios.length) return;

    const input = variantRadios[index];

    if (!input.disabled) {
      input.click();

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );

      const img = input
        .closest('.var_radios')
        ?.querySelector('.main_image_var');

      if (img) {
        updateGalleryImage(img.src.split('?')[0]);
      }

      updateColorText(input.value);

      currentIndex = index;
    }
  }

  variantRadios.forEach((input, index) => {
    input.addEventListener('change', () => {
      variantHasBeenSelected = true;

      const img = input
        .closest('.var_radios')
        ?.querySelector('.main_image_var');

      if (img) {
        updateGalleryImage(img.src.split('?')[0]);
      }

      updateColorText(input.value);

      colorShownText?.classList.remove('hidden');
      colorImageWarning?.classList.add('hidden');

      currentIndex = index;
    });
  });

  function updateColorText(value) {
    console.log("colorTextOutput >>> ", colorTextOutput);

    const colorShowDiv = document.querySelector('.color-showtext');

    if (colorTextOutput && colorShowDiv) {
      if (value && value.trim() !== "") {
        colorTextOutput.textContent = value;
      }
    }
  }

  /*
   * If customer has selected a variant
   * and then clicks ANY gallery thumbnail,
   * replace "Color Shown" with warning.
   */
  document.addEventListener('click', function (event) {
    const thumbnail = event.target.closest(
      '.main-product-media__thumbnails button'
    );

    if (!thumbnail || !variantHasBeenSelected) return;

    colorShownText?.classList.add('hidden');
    colorImageWarning?.classList.remove('hidden');

    document
      .querySelectorAll('.bottom_variant_show .active_varmeta')
      .forEach(item => item.classList.remove('active_varmeta'));
  });

  nextButton?.addEventListener('click', () => {
    let nextIndex = currentIndex + 1;

    if (nextIndex >= variantRadios.length) {
      nextIndex = 0;
    }

    selectVariant(nextIndex);
  });

  prevButton?.addEventListener('click', () => {
    if (currentIndex === 0 && featuredImage) {
      updateGalleryImage(featuredImage);
    } else {
      let prevIndex = currentIndex - 1;

      if (prevIndex < 0) {
        prevIndex = variantRadios.length - 1;
      }

      selectVariant(prevIndex);
    }
  });


  //Coll description Read more / Read less
    const toggleButton = document.querySelector('.read-more-toggle');
    const textWrapper = document.querySelector('.coll_text-wrapper');
    const parent = document.querySelector('.toggle-parent');

    if (toggleButton && textWrapper) {
      toggleButton.addEventListener('click', function () {
        textWrapper.classList.toggle('expanded');
        parent.classList.toggle('desc-expanded'); // new
        toggleButton.textContent = textWrapper.classList.contains('expanded') ? 'Read less' : 'Read more';
      });
    }

});